/** Largest frame we will accept from the document, as a multiple of the paper estimate. */
const MAX_PAPER_MULTIPLE = 20;

/**
 * The document's own height wins when it reported a usable one. The paper estimate has to
 * guess both the paper size and the page count, so it is only the fallback — but the value
 * arrives from another origin over a protocol shared with other embedded documents, so it is
 * validated and capped here rather than trusted.
 */
export const resolveFrameHeight = (
  documentHeight: number | undefined,
  paperTotalHeight: number,
): number => {
  if (typeof documentHeight !== "number" || !Number.isFinite(documentHeight) || documentHeight <= 0) {
    return paperTotalHeight;
  }

  return Math.min(documentHeight, paperTotalHeight * MAX_PAPER_MULTIPLE);
};
